import React, { FC, useState, useEffect } from 'react';
import { getDatePickerFormat, getDateFnsLocale } from 'utils/format';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';

type StatusDatePickerProps = {
    onChangeDate: (date: Date | null) => void;
    selectedDate?: Date | null;
};

const StatusDatePicker: FC<StatusDatePickerProps> = ({ onChangeDate, selectedDate }: StatusDatePickerProps) => {
    const [date, setDate] = useState<Date | null>(new Date());
    const { t: translate } = useTranslation(['common']);

    useEffect(() => {
        if (selectedDate) {
            setDate(selectedDate);
        }
    }, [selectedDate]);

    const handleChange = (date: Date | null) => {
        setDate(date);
        onChangeDate(date);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsLocale()}>
            <DatePicker
                format={getDatePickerFormat()}
                label={translate('DATE')}
                maxDate={new Date()}
                value={date}
                onChange={handleChange}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        margin: 'dense',
                        inputProps: { 'data-test': 'status-date-picker.date-input' },
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default StatusDatePicker;
